import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '@/ducks';
import { logout } from '@/ducks/auth';
import { HiMenu, HiX } from 'react-icons/hi';
import { useLanguage } from '@/contexts/LanguageContext';
import './Header.css';

export default function Header() {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { language, setLanguage, t } = useLanguage();
  const isAuthenticated = useSelector(
    (state: RootState) => state.auth.isAuthenticated
  );
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isLandingHome = location.pathname === '/';

  const handleLogout = () => {
    dispatch(logout());
    navigate('/');
    setIsMenuOpen(false);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className={`header${isLandingHome ? ' header--landing' : ''}`}>
      <div className="container">
        <div className="header-content">
          <Link to="/" className="header-logo" onClick={handleLinkClick}>
            <span
              className="header-logo-image"
              role="img"
              aria-label={language === 'en' ? 'Playbase' : 'Площадка'}
            />
            <span className="header-logo-text">{language === 'en' ? 'Playbase' : 'Площадка'}</span>
          </Link>
          <button 
            className="header-menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <HiX /> : <HiMenu />}
          </button>
          <nav className={`header-nav ${isMenuOpen ? 'header-nav-open' : ''}`}>
            <Link
              to="/"
              className={`header-nav-link${location.pathname === '/' ? ' header-nav-link--active' : ''}`}
              onClick={handleLinkClick}
            >
              {t('common.home')}
            </Link>
            {/* Временно скрыты вкладки Площадки и Встречи */}
            {/* <Link to="/playgrounds" className="header-nav-link" onClick={handleLinkClick}>
              {t('common.playgrounds')}
            </Link>
            <Link to="/meetings" className="header-nav-link" onClick={handleLinkClick}>
              {t('common.meetings')}
            </Link> */}
            <Link
              to="/for-landlords"
              className={`header-nav-link header-nav-link-landlord${location.pathname === '/for-landlords' ? ' header-nav-link--active' : ''}`}
              onClick={handleLinkClick}
            >
              {t('common.forLandlords')}
            </Link>
            <div className="header-language-switcher">
              <button
                className={`lang-btn ${language === 'ru' ? 'active' : ''}`}
                onClick={() => setLanguage('ru')}
                aria-label="Switch to Russian"
              >
                RU
              </button>
              <button
                className={`lang-btn ${language === 'en' ? 'active' : ''}`}
                onClick={() => setLanguage('en')}
                aria-label="Switch to English"
              >
                EN
              </button>
            </div>
            {isAuthenticated && (
              <>
                <Link to="/create-meeting" className="header-nav-link" onClick={handleLinkClick}>
                  {t('common.createMeeting')}
                </Link>
                <Link to="/profile" className="header-nav-link" onClick={handleLinkClick}>
                  {t('common.profile')}
                </Link>
                <button onClick={handleLogout} className="btn btn-secondary">
                  {t('common.logout')}
                </button>
              </>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
}
